import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { ExecutionInspectorClient } from '@/components/inspector/execution-inspector-client';
import { api } from '@/lib/api';

export default function ExecutionInspectorPage(): import('react/jsx-runtime').JSX.Element {
  const { id: projectId = '', eid: executionId = '' } = useParams<{ id: string; eid: string }>();

  const { data, isLoading } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => api.getProject(projectId),
    enabled: projectId.length > 0,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return (
      <div
        className="flex min-h-[200px] items-center justify-center"
        data-testid="inspector-project-loading"
      >
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-muted border-t-foreground" />
      </div>
    );
  }

  const project = data?.project;
  if (project?.id == null) {
    return (
      <div
        className="flex min-h-[200px] flex-col items-center justify-center gap-2 p-8 text-muted-foreground"
        data-testid="inspector-project-error"
      >
        <p className="text-sm">Unable to load project for inspector.</p>
        <p className="text-xs font-mono opacity-80">
          projectId={projectId || '(missing)'} executionId={executionId || '(missing)'}
        </p>
      </div>
    );
  }

  return (
    <div data-testid="inspector-project-ready">
      <ExecutionInspectorClient
        executionId={executionId}
        projectId={projectId}
        agentUrl={project.agentUrl ?? null}
      />
    </div>
  );
}
